var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"notification-badge",on:{"click":function($event){return _vm.$emit('click')}}},[_c('span',{staticClass:"icon iconfont icon-notification"}),(_vm.unreadCount > 0)?_c('div',{staticClass:"badge"},[_vm._v(_vm._s(_vm.formattedCount))]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }